export default __webpack_public_path__ + "static/backgroundChampions-bd363d261090ffc3e80ff674b59a2a21.jpg";